<!--
  ~ Copyright (c) 2019. ProVision Media Group Ltd. <https://provision.bg>
  ~ Venelin Iliev <http://veneliniliev.com>
  -->

<div class="modal-header">
  <h4 class="modal-title">
    {{ 'LINKS.LINKS_FORM.LINKS_MANAGER' | translate }}
    <span *ngIf="data && data.name"> - {{ data.name }}</span>
  </h4>
  <button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss('Cross click')">
  </button>
</div>

<div class="modal-body">
  <form id="links-form" novalidate>
    <div class="row g-0">
      <div class="col-sm-3">
        <div class="locales-menu">
          <ng-scrollbar class="ps">
            <div class="modal-section-title mt-2 mb-2 ps-2">
              {{ 'LINKS.LINKS_FORM.WEBSITES_LIST_TITLE' | translate }}
            </div>

            <div
              *ngFor="let websiteLocale of companyWebsiteLocales"
              (click)="selectCompanyWebSiteLocale(websiteLocale.id)"
              class="website-locale d-flex"
              [ngClass]="{ active: currentWebsiteLocaleId === websiteLocale.id }"
            >
              <div class="ico">
                <i class="fal fa-chevron-right"></i>
              </div>
              <div class="name">{{ websiteLocale.website.name }} - {{ websiteLocale.website.url }}</div>
              <div class="flag">
                <span class="flag-icon" [ngClass]="'flag-icon-' + websiteLocale.locale.locale"></span>
              </div>
            </div>
          </ng-scrollbar>
        </div>
      </div>
      <div class="col-sm-9">
        <div class="locales-content-wrapper">
          <ng-scrollbar class="ps">
            <div *ngIf="!currentWebsiteLocaleId" class="select-website-msg modal-section-title ps-3 mt-2">
              {{ 'LINKS.LINKS_FORM.SELECT_WEBSITE_MSG' | translate }}
            </div>

            <div *ngFor="let websiteLocale of companyWebsiteLocales; let i = index" class="locales-content">
              <div *ngIf="currentWebsiteLocaleId === websiteLocale.id">
                <div class="modal-section-title mt-2 mb-2">
                  {{ getWebsiteLocaleName(websiteLocale.id) }}
                </div>

                <div *ngIf="websiteLocale.links.length <= 0">
                  {{ 'LINKS.LINKS_FORM.NO_LINKS_MSG' | translate }}
                </div>

                <div *ngFor="let link of websiteLocale.links; let j = index" class="single-link">
                  <div class="type">{{ link?.type?.value }}</div>

                  <div class="value">
                    <div class="input-group mb-3">
                      <div class="input-group-prepend" id="button-addon3">
                        <button (click)="copyInputMessage(link.value)" class="btn btn-outline-secondary" type="button">
                          <i class="fal fa-copy"></i>
                        </button>
                        <a class="btn btn-outline-secondary" target="_blank" [attr.href]="link.value">
                          <i class="fal fa-external-link"></i>
                        </a>
                      </div>
                      <input type="text" class="form-control" disabled [value]="link.value" #userinput />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </ng-scrollbar>
        </div>
      </div>
    </div>
  </form>
</div>

<div class="modal-footer">
  <button type="button" class="btn btn-outline-dark btn-xs" (click)="modal.dismiss('Cross click')">
    {{ 'LINKS.LINKS_FORM.CLOSE' | translate }}
  </button>
</div>
